<template>
  <stacked-bar :chart-data="chartData" :loading="loading" stacked-type="percent" chart-v-ax-format="percent"></stacked-bar>
</template>

<script>
import StackedBar from "../../../charts/StackedBar";
import Vue from "vue";

export default {
  name: "FulfillmentPercentage",
  data() {
    return {
      loading: false
    }
  },
  props: ['date-range', 'updateData', 'viewData'],
  components: {StackedBar},
  computed: {
    chartData: function() {
      return this.viewData
    }
  }
}
</script>

<style scoped>

</style>
